import { FormControlModel, FormField } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';
import { allianzFields } from './allianz/allianz-custom-fields';
import { arvalFields } from './arval/arval-custom-fields';
import { standardFields } from './standard/standard-custom-fields';
import { vorwerkFields } from './vorwerk/vorwerk-custom-fields';
import { westlottoFields } from './westlotto/westlotto-custom-fields';

const customFields = new Map<string, FormField[] | FormControlModel[]>();
customFields.set(CustomClients.Allianz, allianzFields);
customFields.set(CustomClients.Arval, arvalFields);
customFields.set(CustomClients.Vorwerk, vorwerkFields);
customFields.set(CustomClients.Standard, standardFields);
customFields.set(CustomClients.WestLotto, westlottoFields);

export { customFields };
